import UnfreezeCardModal from './UnfreezeCardModal';

export default UnfreezeCardModal;
